<template>
  <de-layout-content>
    <div class="structureContent">
      <div class="leftNav">
        <div class="block">
          <div class="treeHeader">
            <i class="el-icon-s-shop"></i>
            <span style="margin-left: 6px">指标管理</span>
            <i class="el-icon-plus" style="margin-left: auto;" @click="addType('floder1')"/>
          </div>

          <el-tree
            ref="datasetTreeRef"
            :data="navList"
            highlight-current
            node-key="id"
            :props="{
              label: 'showName',
              children: 'children',
            }"
            @node-click="nodeClick"
            :default-expanded-keys="expandedArray"
          >
            <span
              slot-scope="{ node, data }" 
              class="treeItem"
            >
              <span
                style="
                  flex: 1;
                  overflow: hidden;
                  margin-left: 6px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                :title="data.showName"
                >
                {{ data.showName }}
              </span>
              <span class="icons">
                <i class="el-icon-plus" v-if="data.level === 1" @click.stop="addType('floder1',data)"/>
                <span
                  style="margin-left: 12px"
                  @click.stop
                >
                  <el-dropdown
                    trigger="click"
                    size="small"
                    placement="bottom-start"
                    @command="(type) => clickMore(type, data, node)"
                  >
                    <span class="el-dropdown-link">
                      <i class="el-icon-more" />
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      class="de-card-dropdown"
                    >
                      <el-dropdown-item command="rename">
                        <svg-icon icon-class="de-ds-rename"/>
                        {{ $t('dataset.rename') }}
                      </el-dropdown-item>
                      <el-dropdown-item command="delete">
                        <svg-icon icon-class="de-ds-trash"/>
                        {{ $t('dataset.delete') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="mainCon">
        <div class="search">
          <el-input
            placeholder="搜索指标"
            prefix-icon="el-icon-search"
            v-model.trim="orxxxName"
            style="width: 208px"
            class="mr10"
            @blur="searchValue"
          >
          </el-input>
          <el-button type="primary" @click="addType('floder2',tableType)">添加分类</el-button>
          <!-- <el-button type="primary" @click="addData" >添加数据</el-button> -->
        </div>
        <template v-if="tableData.length">
          <el-collapse v-model="fieldActiveNames" class="style-collapse">
            <el-collapse-item v-for="(item, index) in tableData" :key="index" :name="item.showName" class="dimension" :title="item.showName">
              <div class="collapseBtn">
                <i class="el-icon-edit mr20" @click="collapseAct('edit',item)"></i>
                <i class="el-icon-delete" @click="collapseAct('delete',item)"></i>
              </div>
              <el-table :data="item.children" border style="width: 100%">
                <el-table-column prop="fieldName" label="指标名称" align="center">
                  <template slot-scope="scope">
                    <!-- <el-input
                    v-model="scope.row.fieldName"
                    @blur="inputBlur(scope.row)"
                    placeholder="指标名称"
                  ></el-input> -->
                    <span>{{ scope.row.showName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" align="center">
                </el-table-column>
                <el-table-column prop="getType" label="指标获取方式" align="center">
                </el-table-column>
                <el-table-column prop="dataType" label="指标类型" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.dataType | getTicketType }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="说明"
                  align="center"
                ></el-table-column>
                <el-table-column prop="groupId" label="指标来源" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.groupId ? "自定义" : "默认" }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      plain
                      size="small"
                      type="primary"
                      @click="hallAddEdit(scope.row)"
                      >编辑</el-button>
                    <el-popconfirm
                      title="确定删除吗？该操作不会撤销"
                      @confirm="handleDelete(scope.row)"
                    >
                      <el-button
                        plain
                        size="small"
                        type="danger"
                        slot="reference"
                        style="margin-left: 10px"
                        >删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            <div>
              <el-button
                @click="addAction(item, index)"
                style="width: 100%; color: #1890ff; margin: 2px 0 4px 0;border: 1px solid #1890ff; background-color: unset;"
                >+添加指标</el-button>
            </div>
            </el-collapse-item>
          </el-collapse>
        </template>
        <template v-else>
          <el-empty description="暂无数据"></el-empty>
        </template>
      </div>
    </div>

    <el-dialog
      :title="formData.id ? '修改指标' : '添加指标'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
      >
        <div>
          <el-form-item label="指标名称:" prop="showName">
            <el-input
              v-model="formData.showName"
              autocomplete="off"
              placeholder="请输入指标名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="单位:" prop="unit">
            <el-input
              v-model="formData.unit"
              placeholder="请输入单位"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item label="指标获取方式:" prop="getType">
            <el-checkbox-group v-model="formData.getType">
              <el-checkbox label="添加">添加</el-checkbox>
              <el-checkbox label="上传">上传</el-checkbox>
            </el-checkbox-group>
          </el-form-item>``

          <el-form-item label="指标类型:" prop="dataType">
            <el-radio-group v-model="formData.dataType">
              <el-radio label="double">数字</el-radio>
              <!-- <el-radio label="pic">图片</el-radio> -->
              <el-radio label="varchar">多行文本</el-radio>
              <el-radio label="fulltext">单行文本</el-radio>
              <el-radio label="option">单选</el-radio>
              <el-radio label="date">日期</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="单选值:"
            required
            v-if="formData.dataType === 'option'"
          >
            <div class="cellList" v-if="optionList.length">
              <div
                class="cell"
                v-for="(item, index) in optionList"
                :key="index"
              >
                <div class="input">
                  <el-input
                    v-model="item.option"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
                <div class="icon" @click="delOtionData(item, index)">
                  <i
                    class="el-icon-close"
                    style="color: #fff; font-size: 24px"
                  ></i>
                </div>
              </div>
            </div>
            <div class="addOption">
              <el-button
                style="width: 100%; color: #1890ff; margin: 1px 0 4px 0"
                @click="addOtionData"
                >+添加值</el-button
              >
            </div>
          </el-form-item>

          <el-form-item label="说明:">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="formData.remark"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formData')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="typeForm.id ? '重命名' : '新建分类'"
      :visible.sync="typeVisible"
      width="600px"
    >
      <el-form
        :model="typeForm"
        :rules="rules"
        ref="typeForm"
        label-width="100px"
      >
        <el-form-item :label="typeForm.id ? '重命名' :'分类名称:'" prop="showName">
          <el-input
            v-model="typeForm.showName"
            autocomplete="off"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('typeForm')">确 定</el-button
        >
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>
// import Tree from "./tree.vue";
import * as API_Member from "@/api/member/member";
import TeachingVideo from "@/views/wizard/details/TeachingVideo.vue";
export default {
  components: { TeachingVideo },
  data() {
    return {
      fieldComment: "", // 指标名称
      navIndex: "0-0",
      dialogFormVisible: false,
      userId: this.$store.state.user.user.userId, //用户id
      formData: {
        getType: ["添加", "上传"],
        dataType: "double",
      },
      typeForm: {
        pid: null,
        level: null,
        nodeType: '',
        showName: '',
        orxxxName: ''
      },
      typeVisible: false,
      activeNames: ["生理生化"],
      navList: [],
      tableType: {},
      tableData: [],
      optionList: [],
      expandedArray: [],
      rules: {
        showName: [
          { required: true, message: "请输入指标名称", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入单位", trigger: "change" }],
        getType: [
          { required: true, message: "请选择指标获取方式", trigger: "change" },
        ],
        dataType: [
          { required: true, message: "请选择指标类型", trigger: "change" },
        ],
      },
      formParams: {},
      selectNavTableCommentParams: {},
      selectNavPackageParams: {},

      // 选中的params
      selectParams: {},
      orxxxName: "",
      fieldActiveNames: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getFieldNavigationTreeList();
    },
    async getFieldNavigationTreeList() {
      // this.tableData = [];
      let params = {
        pageNum: 1,
        pageSize: 10,
        showName: "",
        id: this.userId,
        nodeType: "floder1",
        orxxxName: this.orxxxName || "",
      };
      API_Member.projectTreeInfo(params).then((res) => {
        let arr = []
        this.navList = this.mapTree(res.data);
        console.log(this.navList);
        // this.tableData = this.navList[0].children.length
        //   ? this.navList[0].children[0].child
        //   : [];
        // this.$nextTick(() => {
        //   this.expandedArray = this.navList[0].children.length
        //     ? [this.navList[0].children[0].id]
        //     : [];
        //   this.$refs.datasetTreeRef.setCurrentKey(
        //     this.navList[0].children.length
        //       ? this.navList[0].children[0].id
        //       : ""
        //   );
        // });
        if (!this.orxxxName) {
          // 搜索
          if(this.tableType.id) {
            this.expandedArray = [this.tableType.id]
            this.$nextTick(() => {
              this.$refs.datasetTreeRef.setCurrentKey(this.tableType.id)
              console.log(this.$refs.datasetTreeRef.getNode(this.tableType.id).data)
              this.tableData =  this.$refs.datasetTreeRef.getNode(this.tableType.id).data.child
              for (let i = 0; i < this.tableData.length; i++) {
                const ele = this.tableData[i];
                console.log(ele.showName);
                arr.push(ele.showName)
              }
              this.fieldActiveNames = arr
            });
          } else {
            this.tableData = this.navList[0].children.length
              ? this.navList[0].children[0].child
              : [];
            this.tableType = this.navList[0].children.length
              ? this.navList[0].children[0]
              : {};
            console.log(this.tableType)
            this.$nextTick(() => {
              this.expandedArray = this.navList[0].children.length
                ? [this.navList[0].children[0].id]
                : [];
              this.$refs.datasetTreeRef.setCurrentKey(
                this.navList[0].children.length
                  ? this.navList[0].children[0].id
                  : "",
              );
            });
          }
        } else {
          // 默认
          this.$nextTick(() => {
            this.$refs.datasetTreeRef.setCurrentKey(
              this.selectParams.id
                ? this.selectParams.id
                : this.navList[0].children.length
                  ? this.navList[0].children[0].id
                  : "",
            );
            // 获取选中的值
            let data = this.$refs.datasetTreeRef.getCurrentNode();
            console.log(data)
            if (!data.children.length && data.pid) {
              this.tableType = data
              this.tableData = data.child;
            } else {
              console.log(1111);
            }
          });
        }
        console.log(this.tableData);
        for (let i = 0; i < this.tableData.length; i++) {
          const ele = this.tableData[i];
          console.log(ele.showName);
          arr.push(ele.showName)
        }
        this.fieldActiveNames = arr
      });
    },
    mapTree(data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        const ele = data[i];
        ele.child = ele.children;
        if (
          ele.nodeType == "floder1" &&
          ele.children.length &&
          ele.children[0].nodeType == "floder1"
        ) {
          ele.children = this.mapTree(ele.children);
        } else {
          ele.children = [];
        }
        arr.push(ele);
      }
      // console.log(arr, "arr");
      return arr;
    },
    handleChange(val) {
      console.log(val);
    },
    searchValue() {
      this.getFieldNavigationTreeList();
      // this.getFieldDetailTreeList(this.selectNavTableCommentParams);
    },
    selectChildItem(item, index, childItem, childIndex) {
      console.log(item, index, childItem, childIndex);
    },
    nodeClick(data) {
      this.selectParams = data
      // console.log(data, "点击的data");
      if(data.nodeType == "floder1") {
        this.tableType = {}
      }
      if (!data.children.length && data.pid) {
        this.tableType = data
        this.tableData = data.child;
        // console.log(this.tableData, "tableData");
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          const ele = this.tableData[i];
          // console.log(ele.showName);
          arr.push(ele.showName)
        }
        this.fieldActiveNames = arr
      }
    },
    clickMore(type, data, node) {
      switch (type) {
        case 'rename':
          this.editType(data)
          break
        case 'delete':
          this.delType(data)
          break
      }
    },
    addType(type,data) {
      // console.log(data);
      // console.log(type);
      this.typeForm = {
        pid: data ? data.id : '',
        orxxxName: data ? data.orxxxName : '',
        level: data ? data.level + 1 : 1,
        nodeType: type,
        showName: ''
      }
      console.log(this.typeForm);
      this.typeVisible = true
    },
    editType(data) {
      this.typeForm = JSON.parse(JSON.stringify(data))
      console.log(this.typeForm);
      this.typeVisible = true
    },
    delType(data) {
      if(data.child&&data.child.length || data.children&&data.children.length) {
        this.$message({
          message: "有子级数据，请先删除子数据",
          type: 'error'
        })
      } else {
        this.$confirm(`确认删除${data.showName}分类及分类内的所有内容`, "操作确认", {
          confirmButtonText: this.$t('chart.confirm'),
          cancelButtonText: this.$t('chart.cancel'),
          type: 'warning'
        }).then(() => {
          this.handleDelete(data)
        }).catch(() => {
        })
      }
    },
    addAction(item, index) {
      console.log(item, index);
      this.dialogFormVisible = true;
      this.formParams = item;
      console.log(this.formParams, "this.formParams");
      this.formData = {
        dataType: "double",
        getType: ["添加", "上传"],
      };
    },
    collapseAct(type,item) {
      if(type == 'edit') {
        this.editType(item)
      } else {
        this.delType(item)
      }
    },
    // 编辑
    hallAddEdit(row) {
      this.dialogFormVisible = true;
      this.formData = {
        ...row,
        getType: row.getType ? row.getType.split(",") : [],
      };
      console.log(this.formData);
    },
    inputBlur(row) {
      console.log(row);
      let data = {
        ...row,
      };
      console.log(data);
      API_Member.fieldEdit(data).then((res) => {
        console.log(res);
        this.getFieldDetailTreeList(this.selectNavTableCommentParams);
      });
    },

    // 删除
    handleDelete(row) {
      console.log(row);
      API_Member.projectDelIndex({
        id: row.id,
      }).then((res) => {
        console.log(res, "edit");
        this.getFieldNavigationTreeList();
      });
    },

    addOtionData() {
      let data = {
        option: "",
      };
      this.optionList.push(data);
    },

    delOtionData(item, index) {
      this.optionList.splice(index, 1);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let data = {
          //   nodeType: this.selectParams.nodeType,
          //   pid: this.selectParams.pid,
          //   level: this.selectParams.level,
          //   ...this.formData,
          //   options: this.optionList.length
          //     ? JSON.stringify(this.optionList)
          //     : "",
          // };
          let data = {}
          if(formName == 'typeForm') {
            data = this.typeForm
          } else {
            data = {
              nodeType: "index",
              pid: this.formParams.id,
              level: this.formParams.level + 1,
              ...this.formData,
              getType: this.formData.getType.join(","),
              options: this.optionList.length
                ? JSON.stringify(this.optionList)
                : "",
            };
          }

          console.log(data);
          // return
          if (data.id) {
            API_Member.projectEditIndex(data).then((res) => {
              console.log(res, "edit");
              this.typeVisible = false;
              this.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.optionList = [];
              this.getFieldNavigationTreeList();
            });
          } else {
            API_Member.projectAddIndex(data).then((res) => {
              console.log(res, "edit");
              this.typeVisible = false;
              this.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.optionList = [];
              this.getFieldNavigationTreeList();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  filters: {
    getTicketType(val) {
      switch (val) {
        case "double":
          return "数字";
        case "pic":
          return "图片";
        case "varchar":
          return "多行文本";
        case "fulltext":
          return "单行文本";
        case "option":
          return "单选";
        case "date":
          return "日期";
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-tree-node__expand-icon.is-leaf {
  visibility: hidden;
}
.filePointer {
  width: 100%;
  height: 100%;
}
.treeItem {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  .icons {
    color: #fff;
    visibility: hidden;
    margin-left: 10px;
    padding-right: 8px;
    .el-icon-more {
      color: #fff;
    }
  }
  &:hover .icons {
    visibility: visible;
  }
}
// .father .child {
//   visibility: hidden;
// }

// .father:hover .child {
//   visibility: visible;
// }
.structureContent {
  display: flex;
  height: 100%;
  .leftNav {
    width: 240px;
    margin-right: 20px;
    padding-right: 20px;
    background-color: #141937;
    border-right: 1px solid rgba(255,255,255,.1);

    .treeHeader {
      display: flex;
      align-items: center;
      // height: 40px;
      margin-bottom: 10px;
      // padding: 0 12px;
      color: #fff;
    }
    .navItem {
      height: 52px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .active {
      background-color: rgba(247, 250, 253, 1);
      color: rgb(64, 158, 255);
    }
    /deep/ .el-tree-node__content {
      height: 40px;
    }
    /deep/
      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      color: rgb(64, 158, 255);
    }
  }

  .mainCon {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    .search {
      margin-bottom: 22px;
    }
    .levelHeader {
      // padding: 0 12px;
      height: 36px;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      // background-color: rgba(240, 247, 255, 1);
    }
    .levelLine {
      .el-button {
        background-color: inherit !important;
        border-radius: 0 !important;
        border: 1px solid #1890ff !important;
        color: #1890ff !important;
        &:hover {
          background-color: #1890ff !important;
          color: #fff !important;
        }
      }
    }
  }
}
.cellList {
  margin-bottom: 22px;
  .cell {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .input {
      flex: 1;
      min-width: 0;
    }

    .icon {
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  .cell:last-child {
    margin-bottom: 0;
  }
}
.addOption {
  .el-button {
    background-color: inherit !important;
    border-radius: 0 !important;
    border: 1px solid #1890ff !important;
    color: #1890ff !important;
    &:hover {
      background-color: #1890ff !important;
      color: #fff !important;
    }
  }
}
.style-collapse {
  border: none;
  background-color: #141937;
  .select-type {
    width: 180px;
    ::v-deep.el-input__inner {
      padding-left: 32px;
    }
  }

  .input-type {
    width: 180px;
  }

  .select-svg-icon {
    position: absolute;
    left: 24px;
    top: 10px;
  }

  ::v-deep.el-collapse-item__header {
    color: #fff;
    font-size: 16px;
    height: 36px;
    line-height: 36px;
    padding: 0 0 0 30px;
    position: relative;
    border-bottom: 1px solid rgba(31, 35, 41, 0.15);
  }

  ::v-deep.el-checkbox {
    margin-left: 8px;
  }

  .dimension {
    ::v-deep.el-collapse-item__header {
      background-color: rgba(51, 112, 255, 0.1);
    }
  }

  .quota {
    ::v-deep.el-collapse-item__header {
      background-color: rgba(4, 180, 156, 0.1);
    }
  }

  ::v-deep.el-collapse-item__arrow {
    position: absolute;
    top: 9px;
    left: 13px;
    font-size: 12px;
  }

  ::v-deep.el-collapse-item__arrow::before {
    content: "\E791";
  }

  ::v-deep.el-collapse-item__arrow.is-active {
    transform: rotate(90deg);
  }
}
.style-collapse ::v-deep .el-collapse-item {
  position: relative;
}
.style-collapse ::v-deep .el-collapse-item__wrap {
  background-color: #141937;
  border-bottom: 0 solid #e6ebf5 !important;
  .collapseBtn {
    position: absolute;
    right: 20px;
    top: 5px;
    z-index: 10;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
